<script setup lang="ts">
import { onMounted, ref } from 'vue';

interface AppSlideUpAndDownTransitionEmits {
  (eventName: 'after-leave'): void;
}
const emit = defineEmits<AppSlideUpAndDownTransitionEmits>();

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <transition name="up-and-down-slide" @after-leave="emit('after-leave')">
    <slot v-if="isVisible" />
  </transition>
</template>

<style scoped lang="scss">
.up-and-down-slide-enter-active,
.up-and-down-slide-leave-active {
  transition: transform var(--transition-short);
}

.up-and-down-slide-enter-from,
.up-and-down-slide-leave-to {
  transform: translateY(100%);
}
</style>
